module.exports = __webpack_public_path__ + "static/img/teBuContent5.0b3f905.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teBuContent5.png
// module id = SDy9
// module chunks = 2